import { useEffect, useState } from "react";
import { useDebounce } from "react-use";

export function useDebouncedUrlMatcher(
    content: string,
    onFirstMatchDebounced: (match: string | undefined) => void,
) {
    const [match, setMatch] = useState<string>();
    useEffect(() => {
        if (!content.length) {
            return;
        }
        setMatch(extractValidUrl(content)?.[0] ?? undefined);
        return () => {
            setMatch(undefined);
        };
    }, [content]);

    useDebounce(() => onFirstMatchDebounced(match), 400, [content, match]);
}

function extractValidUrl(content: string): string[] {
    const matches = content.match(
        /\b(?:https?:\/\/)?(?<!@)([\w-]+(?:\.[\w-]+)*\.[a-zA-Z]{2,})([/\w\-?=%&.#]*)?(?!@)\b/gi,
    );

    return matches ?? [];
}
